import {
  AppBar,
  Hidden,
  ThemeProvider,
  StyledEngineProvider,
  Theme,
  Toolbar,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import React from "react";
import Login from "../../../explorer/components/Login/Login";
import AppFooter from "../../components/AppLayout/AppFooter/AppFooter";
import logo from "../../assets/images/SavioIcon.png";
import { themeSettings } from "../../configuration/themeSettings";

const PREFIX = "LoginPage";

const classes = {
  appBar: `${PREFIX}-appBar`,
  toolBar: `${PREFIX}-toolBar`,
  content: `${PREFIX}-content`,
  logo: `${PREFIX}-logo`,
  titleContainer: `${PREFIX}-titleContainer`,
};

const Root = styled("div")(({ theme: Theme }) => ({
  [`& .${classes.appBar}`]: {
    zIndex: Theme.zIndex.drawer + 1,
    flex: "1 0 50px",
    display: "flex",
    position: "relative",
  },

  [`& .${classes.toolBar}`]: {
    paddingLeft: 0,
    paddingRight: 0,
  },

  [`& .${classes.content}`]: {
    display: "flex",
    flexDirection: "row",
    flex: "1 1 auto",
    height: "100%",
    width: "100%",
    overflow: "auto",
    justifyContent: "center",
    alignItems: "center",
  },

  [`& .${classes.logo}`]: {
    cursor: "pointer",
    marginLeft: 10,
    marginRight: 6,
    height: 50,
  },

  [`& .${classes.titleContainer}`]: {
    color: Theme.palette.primary.contrastText,
    paddingLeft: Theme.spacing(1),
    paddingRight: Theme.spacing(3),
    height: 48,
    [Theme.breakpoints.up("sm")]: {
      fontSize: "20px",
    },
    [Theme.breakpoints.down("xl")]: {
      fontSize: "16px",
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
}));

type LoginPageProps = {
  notifyLogin?: any;
};
//

const LoginPage = (props: LoginPageProps) => {
  return (
    <Root style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={themeSettings.main}>
          <AppBar className={classes.appBar} elevation={0}>
            <Toolbar className={classes.toolBar}>
              <img src={logo} className={classes.logo} alt="VDW"></img>
              {/* C'era un Hidden... da fare con mobile (Forse) */}
              <div className={classes.titleContainer}>
                <span>SERVICE PORTAL</span>
              </div>
            </Toolbar>
          </AppBar>

          <div className={classes.content}>
            <Login />
          </div>
          <AppFooter></AppFooter>
        </ThemeProvider>
      </StyledEngineProvider>
    </Root>
  );
};

export default LoginPage;
